module.exports = __webpack_public_path__ + "assets/images/clients/2.png";